import { useContext, useEffect, useState } from 'react';

import { Form, Col } from 'react-bootstrap';

import FormAccordion from '../../../components/forms/FormAccordion';
import hocFrom from '../../../components/forms/HocFrom';
import InputBankCard from '../../../components/inputs/InputBankCard';
import InputControl from '../../../components/inputs/InputControl';
import InputControlMulti from '../../../components/inputs/InputControlMulti';
import InputDate from '../../../components/inputs/InputDate';
import InputFarsi from '../../../components/inputs/InputFarsi';
import InputNationalCode from '../../../components/inputs/InputNationalCode';
import Mobilecheckexist from '../../../components/inputs/Mobilecheckexist';
import Sheba from '../../../components/inputs/Sheba';
import Switchrs from '../../../components/inputs/Switchrs';
import Loader from '../../../components/layout/Loader';
import NumberFormat from 'react-number-format';
import { Space } from 'antd';
import DashboardContext from 'Context';

function FormWorker({
  handelUpdataFrom,
  handelSend,
  loding,
  handelLoadingform,
  LoadingForm,
  dataUpdate,
  handelsetdataForm,
  formdata,
}) {
  const [formvalueAccordion, setFormvalueAccordion] = useState([]);
  const { handelloding } = useContext(DashboardContext);
  const [statuseMobile, setStatuseMobile] = useState(false);

  const handelstatusemobile = (status) => setStatuseMobile(status);

  const handelValue = (name, value) => {
    switch (name) {
      case 'firstName':
        handelsetdataForm({ ...formdata, firstName: value });
        break;
      case 'lastName':
        handelsetdataForm({ ...formdata, lastName: value });
        break;
      case 'fatherName':
        handelsetdataForm({ ...formdata, fatherName: value });
        break;
      case 'tell':
        handelsetdataForm({ ...formdata, tell: value });
        break;
      case 'cellPhone':
        handelsetdataForm({ ...formdata, cellPhone: value });
        break;
      case 'gender':
        handelsetdataForm({ ...formdata, gender: value });
        break;
      case 'cityId':
        handelsetdataForm({ ...formdata, cityId: value });
        break;
      case 'dormId':
        handelsetdataForm({ ...formdata, dormId: value });
        break;
      case 'groupIds':
        handelsetdataForm({ ...formdata, groupIds: value });
        break;
      case 'referrerId':
        handelsetdataForm({ ...formdata, referrerId: value });
        break;
      case 'appActiveFormWorker':
        handelsetdataForm({ ...formdata, appActive: value });
        break;
      case 'isActiveFormWorker':
        handelsetdataForm({ ...formdata, isActive: value });
        break;
      case 'isReadyFormWorker':
        handelsetdataForm({ ...formdata, isReady: value });
        break;
      case 'isAutoPay':
        handelsetdataForm({ ...formdata, isAutoPay: value });
        break;
      case 'mobileType':
        handelsetdataForm({ ...formdata, mobileType: value });
        break;
      case 'workerType':
        handelsetdataForm({ ...formdata, workerType: value });
        break;
      case 'profileBusinessType':
        handelsetdataForm({ ...formdata, profileBusinessType: value });
        break;
      case 'birthDate':
        handelsetdataForm({ ...formdata, birthDate: value });
        break;
      case 'nationalCode':
        handelsetdataForm({ ...formdata, nationalCode: value });
        break;
      case 'pictureFile':
        handelsetdataForm({ ...formdata, pictureFile: value });
        break;
      case 'primaryCategoryId':
        handelsetdataForm({ ...formdata, primaryCategoryId: value });
        break;
      case 'startWork':
        handelsetdataForm({ ...formdata, startWork: value });
        break;
      case 'debitCardNumber':
        handelsetdataForm({ ...formdata, debitCardNumber: value });
        break;
      case 'debtCeiling':
        handelsetdataForm({ ...formdata, debtCeiling: parseInt(value) });
        break;
      case 'description':
        handelsetdataForm({ ...formdata, description: value });
        break;
      case 'isVipFormWorker':
        handelsetdataForm({ ...formdata, isVip: value });
        break;
      case 'hasDisciplineFormWorker':
        handelsetdataForm({ ...formdata, hasDiscipline: value });
        break;
      case 'shebaCode':
        handelsetdataForm({ ...formdata, shebaCode: value });
        break;
      case 'rateStartDate':
        handelsetdataForm({ ...formdata, rateStartDate: value });
        break;

      default:
        break;
    }
  };
  const handelSubmit = (event) => {
    event.preventDefault();
    handelLoadingform(true);
    dataUpdate.firstName ? handelUpdataFrom() : handelSend();
  };

  const handelAccordion = (arry) => {
    if (arry.length > 0) {
      const flatArry = arry.flat();

      setFormvalueAccordion(flatArry);
    }
  };

  useEffect(() => {
    handelsetdataForm({
      ...formdata,
      specificationValueIds: formvalueAccordion,
    });

    return () => { };
  }, [formvalueAccordion]);

  useEffect(() => {
    handelloding(true);
    setTimeout(() => {
      handelloding(false);
    }, 3000);
    return () => {};
  }, []);

  return (
    <>
      {loding ? (
        <Loader />
      ) : (
        <Form>
          <Form.Row>
            <Col>
              <InputFarsi
                name='firstName'
                disabled={dataUpdate.firstName}
                label='نام'
                handelValue={handelValue}
                defaultValue={dataUpdate.firstName}
              />
            </Col>
            <Col>
              <InputFarsi
                name='lastName'
                disabled={dataUpdate.firstName}
                label='نام خانوادگی'
                handelValue={handelValue}
                defaultValue={dataUpdate.lastName}
              />
            </Col>
            {/* <Col> */}
            {/* <InputFarsi name='fatherName' label='نام پدر' handelValue={handelValue} defaultValue={dataUpdate.fatherName} /> */}
            {/* </Col> */}
          </Form.Row>
          <Form.Row>
            <Col>
              <InputControl
                url='/common/genderdropdown'
                disabled={dataUpdate.firstName}
                label='جنسیت'
                name='gender'
                handelValue={handelValue}
                defaultValue={dataUpdate.gender}
              />
            </Col>
            {/* <Col> */}
            {/* <InputDate label='تاریخ تولد' name="birthDate" handelValue={handelValue} defaultValue={dataUpdate.birthDate} /> */}
            {/* </Col> */}
            <Col>
              <InputNationalCode
                label='کدملی'
                name='nationalCode'
                disabled={dataUpdate.firstName}
                handelValue={handelValue}
                defaultValue={dataUpdate.nationalCode}
              />
            </Col>
          </Form.Row>
          <Form.Row>
            {/* <Col> */}
            {/* <InputNumber maxLength='11' label='شماره تلفن ثابت' name='tell' handelValue={handelValue} defaultValue={dataUpdate.tell} /> */}
            {/* </Col> */}
            <Col>
              <Mobilecheckexist
                urlPorfile='Worker'
                disabled={dataUpdate.firstName}
                label='شماره موبایل'
                handelstatusemobile={handelstatusemobile}
                name='cellPhone'
                handelValue={handelValue}
                defaultValue={dataUpdate.cellPhone}
              />
            </Col>
            <Col>
              <InputControl
                url='/common/mobiletypedropdown'
                disabled={dataUpdate.firstName}
                label='نوع موبایل'
                name='mobileType'
                handelValue={handelValue}
                defaultValue={dataUpdate.mobileType}
              />
            </Col>
            <Col>
              <InputDate
                label='تاریخ شروع اعمال امتیاز'
                name='rateStartDate'
                handelValue={handelValue}
                defaultValue={dataUpdate.rateStartDate}
              />
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <InputControl
                url='/dorm/dropdown'
                label='خوابگاه'
                disabled={dataUpdate.firstName}
                name='dormId'
                handelValue={handelValue}
                defaultValue={dataUpdate.dormId}
              />
            </Col>
            <Col>
              <InputControl
                url='/common/workertypedropdown'
                disabled={dataUpdate.firstName}
                label='نوع کار نیرو'
                name='workerType'
                handelValue={handelValue}
                defaultValue={dataUpdate.workerType}
              />
            </Col>
            <Col>
              <InputControl
                url='/common/profilebusinesstypedropdown'
                disabled={dataUpdate.firstName}
                label='نوع بیزینس کار نیرو'
                name='profileBusinessType'
                handelValue={handelValue}
                defaultValue={dataUpdate.profileBusinessType}
              />
            </Col>
            <Col>
              <InputControl
                url='/referrer/dropdown'
                disabled={dataUpdate.firstName}
                label='روش معرفی'
                name='referrerId'
                handelValue={handelValue}
                defaultValue={dataUpdate.referrerId}
              />
            </Col>
          </Form.Row>
          <Form.Row>
            {/* <Col> */}
            {/* <InputControl url='/city/dropdown' label="شهر" name='cityId' handelValue={handelValue} defaultValue={dataUpdate.cityId} /> */}

            {/* </Col> */}
            <Col>
              <Form.Group>
                <Form.Label>
                  سقف بدهی به شرکت <small>(ريال)</small>
                </Form.Label>
                <br />
                <NumberFormat
                  thousandSeparator={','}
                  autoComplete={"off"}
                  defaultValue={dataUpdate?.debtCeiling}
                  disabled={dataUpdate?.firstName}
                  decimalSeparator={'-'}
                  dir='ltr'
                  style={{ height: '50px', width: '100%', border: 'none !important' }}
                />
              </Form.Group>
            </Col>
            <Col>
              <InputControl
                url='/category/dropdown'
                label='گروه خدمات'
                name='primaryCategoryId'
                handelValue={handelValue}
                disabled={dataUpdate.firstName}
                defaultValue={dataUpdate.primaryCategoryId}
              />
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <InputControlMulti
                url='/group/groupdropdown'
                label='دسته خدمات'
                name='groupIds'
                handelValue={handelValue}
                disabled={dataUpdate.firstName}
                defaultValue={dataUpdate.groupIds}
              />
            </Col>
          </Form.Row>

          <Form.Row>
            {/* <Col> */}
            {/* <InputPic label='عکس پروفایل' name='pictureFile' handelValue={handelValue} defaultValue={dataUpdate.pictureFile} /> */}
            {/* </Col> */}
            <Col>
              <InputDate
                label='تاریخ شروع به کار'
                name='startWork'
                handelValue={handelValue}
                defaultValue={dataUpdate.startWork}
              />
            </Col>
            <Col>
              <InputBankCard
                maxLength='16'
                disabled={dataUpdate.firstName}
                label='شماره کارت'
                name='debitCardNumber'
                handelValue={handelValue}
                defaultValue={dataUpdate.debitCardNumber}
              />
            </Col>
            <Col>
              <Sheba
                label='شماره شبا'
                name='shebaCode'
                disabled={dataUpdate.firstName}
                handelValue={handelValue}
                defaultValue={dataUpdate.shebaCode}
              />
            </Col>
          </Form.Row>
          <FormAccordion
            urldata='worker/specificationvaluedropdown'
            handelAccordion={handelAccordion}
            formvalueAccordion={formvalueAccordion}
            defaultValue={dataUpdate.specificationValueIds}
          />
          <Form.Row className='mb-4 mt-5'>
            <Switchrs
              label='آیا اپلیکیشن فعال است؟'
              name='appActiveFormWorker'
              handelValue={handelValue}
              checke={formdata.appActive}
            />
            <Switchrs
              label='آیا مشکل انضباطی دارد؟'
              name='hasDisciplineFormWorker'
              handelValue={handelValue}
              checke={formdata.hasDiscipline}
            />
            <Switchrs
              label='آیا Vip است؟'
              name='isVipFormWorker'
              handelValue={handelValue}
              checke={formdata.isVip}
            />
            <Switchrs
              disabled={true}
              label='آیا یوزر فعال باشد؟'
              name='isActiveFormWorker'
              handelValue={handelValue}
              checke={formdata.isActive}
            />
            <Switchrs
              label='آیا نیرو فعال (آماده بکار) باشد؟'
              disabled={dataUpdate.firstName}
              name='isReadyFormWorker'
              handelValue={handelValue}
              checke={formdata.isReady}
            />
            <Switchrs
              label='آیا پرداخت خودکار باشد؟'
              name='isAutoPay'
              handelValue={handelValue}
              checke={formdata.isAutoPay}
            />
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label htmlFor='descriptionTextarea'>توضیحات بیشتر</label>
                <textarea
                  className='form-control'
                  id='descriptionTextarea'
                  rows='6'
                  defaultValue={dataUpdate ? dataUpdate.description : ''}
                  onChange={(e) => handelValue('description', e.target.value)}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <button
                type='submit'
                className='btn btn-success'
                onClick={handelSubmit}
                disabled={LoadingForm}
              >
                {LoadingForm ? (
                  <i className='fa fa-spinner fa-pulse fa-fw'></i>
                ) : dataUpdate.firstName ? (
                  'ثبت ویرایش'
                ) : (
                  'ثبت'
                )}
              </button>
            </Col>
          </Form.Row>
        </Form>
      )}
    </>
  );
}
export default hocFrom(FormWorker);
